import { Injectable } from '@angular/core';
import { Callbacks } from 'jquery';
declare var Razorpay: any;

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  paymentResponse: any

  constructor() { }
  openRazorpay(amount: number, orderId: string,studentName :string ,mobile:string, callback: (data: any) => void): void {
    const options: any = {
      key: 'rzp_live_AGRzcZx2SWwr98', // ⚠️ use test key in development
      amount: amount * 100,            // amount in paise
      currency: 'INR',
      name: studentName,
      description: 'Payment Description',
      order_id: orderId,
      handler: function (response: any) {
        callback({
          status: 'SUCCESS',
          payment_id: response.razorpay_payment_id,
          order_id: response.razorpay_order_id,
          signature: response.razorpay_signature
        });
      },
      prefill: {
        name: studentName,
        email: 'customer@example.com',
        contact: mobile
      },
      method: {
        upi: true,
        card: true,
        netbanking: false,
        wallet: true
      },
      theme: {
        color: '#3399cc'
      },
      modal: {
        ondismiss: function () {
          callback({
            status: 'cancelled',
            message: 'Payment window closed by user'
          });
        }
      }
    };

    const rzp = new Razorpay(options);

    rzp.open();

    rzp.on('payment.failed', function (response: any) {
      callback({
        status: 'FAILED',
        code: response.error.code,
        description: response.error.description,
        source: response.error.source,
        step: response.error.step,
        reason: response.error.reason,
        order_id: response.error.metadata?.order_id,
        payment_id: response.error.metadata?.payment_id
      });
    });
  }

  getPaymentDetails() {
    return this.paymentResponse;
  }


}
